var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlignHorizontalCenter = function SvgAlignHorizontalCenter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.25 21.5v-4.846H6.5v-2.52h4.75V9.866H3.5V7.346h7.75V2.5h1.5v4.846h7.75v2.52h-7.75v4.269h4.75v2.519h-4.75V21.5z"
  })));
};
export default SvgAlignHorizontalCenter;